import React from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import fonts from "../../styles/fonts"
import { withTranslation } from "gatsby-plugin-react-i18next"
import colors from "../../styles/colors"
import { getIsFrance } from "../../services/locale"
import { getWeddingLink } from "../../services/links"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"

const WeddingLinks = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${breakpoints.lg}) {
    justify-content: flex-start;
    margin-right: 26px;
  }
`

const WeddingLink = styled(Link)`
  ${fonts.openSans};
  color: ${(props) => (props.active ? colors.lightGreen : colors.black)};
  text-transform: uppercase;
  font-weight: 600;
  font-size: 11px;
  line-height: 1;
  border-right: 1px solid;
  padding-right: 8px;
  white-space: nowrap;
  text-decoration: none;
  &:last-of-type {
    border-right: none;
    padding-right: 0;
    padding-left: 8px;
  }

  &:hover {
    color: ${colors.lightGreen};
  }

  @media (min-width: ${breakpoints.md}) {
    font-size: 14px;
  }
`

const WeddingFilter = ({ t }) => {
  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
  const isFrance = getIsFrance()

  const weddingLinks = [
    {
      title: t("plp.filter.wedding_women"),
      link: getWeddingLink(),
      links: [
        isFrance ? "/or-jaune-alliances/" : "/yellow-gold-wedding-rings-bands/",
        isFrance ? "/or-blanc-alliances/" : "white-gold-wedding-rings-bands/",
        isFrance ? "/or-rose-alliances/" : "rose-gold-wedding-rings-bands/",
      ],
    },
    {
      title: t("plp.filter.wedding_men"),
      link: isFrance ? "/alliances-pour-lui/" : "/wedding-bands-for-him/",
      links: [
        isFrance
          ? "/or-jaune-alliances-pour-lui/"
          : "/yellow-gold-wedding-rings-bands-for-him/",

        isFrance
          ? "/or-blanc-alliances-pour-lui/"
          : "/white-gold-wedding-rings-bands-for-him/",

        isFrance
          ? "/or-rose-alliances-pour-lui/"
          : "/rose-gold-wedding-rings-bands-for-him/",
      ],
    },
  ]

  const location = useLocation()

  const pathname =
    activeEnv === "us"
      ? location.pathname
      : location.pathname.replace(`/${activeEnv}/`, "/")

  return (
    <WeddingLinks>
      {weddingLinks.map((link) => {
        const isActive =
          link.link?.includes(pathname) ||
          link.links.some((colorLink) => colorLink.includes(pathname))
        return (
          <WeddingLink to={link.link} active={isActive}>
            {link.title}
          </WeddingLink>
        )
      })}
    </WeddingLinks>
  )
}

export default withTranslation()(WeddingFilter)
